import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register, error } = useAuth();
  const [f, setF] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await register(f);
      toast.success(`Welcome, ${u.name}!`);
      nav("/");
    } catch {
      /* handled */
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto grid min-h-[80vh] max-w-md place-items-center px-4">
      <div className="w-full rounded-3xl border border-stone-200 bg-white p-8 shadow-sm">
        <h1 className="font-serif text-4xl tracking-tight">Create account</h1>
        <p className="mt-1 text-sm text-stone-500">Start ordering in seconds.</p>
        <form onSubmit={submit} className="mt-6 space-y-3">
          <button
            type="button"
            data-testid="google-signup-btn"
            onClick={() => {
              // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
              const redirectUrl = window.location.origin + "/";
              window.location.href =
                "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
            }}
            className="flex w-full items-center justify-center gap-2 rounded-full border border-stone-300 bg-white py-3 text-sm font-semibold text-stone-800 hover:bg-stone-50"
          >
            <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
              <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.7-6.7C35.6 2.5 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.3l7.9 6.1C12.5 13.2 17.8 9.5 24 9.5z" />
              <path fill="#4285F4" d="M46.9 24.6c0-1.6-.1-2.7-.4-3.9H24v7.4h12.9c-.3 2-1.7 5-4.9 7.1l7.6 5.9c4.5-4.2 7.3-10.3 7.3-16.5z" />
              <path fill="#FBBC05" d="M10.5 28.6a14.5 14.5 0 0 1 0-9.2l-7.9-6.1A24 24 0 0 0 0 24c0 3.9.9 7.6 2.6 10.7l7.9-6.1z" />
              <path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.6-5.9c-2 1.4-4.8 2.4-8.3 2.4-6.2 0-11.5-3.7-13.5-9.1l-7.9 6.1C6.5 42.6 14.6 48 24 48z" />
            </svg>
            Sign up with Google
          </button>
          <div className="relative py-2 text-center">
            <span className="relative z-10 bg-white px-2 text-xs uppercase tracking-widest text-stone-400">or</span>
            <div className="absolute left-0 right-0 top-1/2 h-px bg-stone-200" />
          </div>
          {[
            ["name", "Full name", "text"],
            ["email", "Email", "email"],
            ["phone", "Mobile number", "tel"],
            ["password", "Password", "password"],
          ].map(([k, label, type]) => (
            <div key={k}>
              <label className="text-xs font-semibold text-stone-600">{label}</label>
              <input
                data-testid={`register-${k}`}
                required={k !== "phone"}
                type={type}
                value={f[k]}
                onChange={(e) => setF({ ...f, [k]: e.target.value })}
                className="mt-1 w-full rounded-xl border border-stone-200 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-stone-700"
              />
            </div>
          ))}
          {error && (
            <p data-testid="register-error" className="rounded-lg bg-red-50 p-2 text-xs text-red-700">
              {error}
            </p>
          )}
          <button
            data-testid="register-submit"
            disabled={busy}
            className="w-full rounded-full bg-orange-600 py-3 text-sm font-semibold text-white hover:bg-orange-700 disabled:opacity-50"
          >
            {busy ? "Creating..." : "Create account"}
          </button>
        </form>
        <p className="mt-4 text-center text-xs text-stone-500">
          Already have an account?{" "}
          <Link to="/login" className="font-semibold text-stone-800 hover:underline">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
